import React from "react";
import { NavLink } from "react-router-dom";
import { FaBullhorn, FaRss, FaThLarge } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import "./styles/AdMenu.css";

const MENU_ITEMS = [
  { to: "/home", label: "ads_group", icon: FaThLarge, exact: true },
  { to: "/wall", label: "ads_recently", icon: FaRss },
];

function AdMenu() {
  return (
    <section className="ad-menu-card">
      <header className="ad-menu-card__header">
        <span className="ad-menu-card__header-icon" aria-hidden="true">
          <FaBullhorn />
        </span>
        <h2 className="ad-menu-card__title">
          <Translate value="ads" />
        </h2>
      </header>

      <nav className="ad-menu-card__nav" aria-label="Ads navigation">
        {MENU_ITEMS.map(({ to, label, icon: Icon, exact }) => (
          <NavLink
            key={to}
            to={to}
            exact={exact}
            className="ad-menu-card__link"
            activeClassName="is-active"
          >
            <span className="ad-menu-card__link-icon" aria-hidden="true">
              <Icon />
            </span>
            <span className="ad-menu-card__link-label">
              <Translate value={label} />
            </span>
          </NavLink>
        ))}
      </nav>
    </section>
  );
}

export default AdMenu;
